import devImage from '../../assets/dev_image4_re.png';

import './DevSection.css';


const DevSection = () => {



  return (
      <div className="dev-section">
        <div className="content-row">
          <div className="left-texts">
          <h1 className="heading"
              data-aos="fade-right"         
              data-aos-duration="600"    
          >
            Powerful blockchain performance, effortless on your device.
          </h1>
          <p className="subtext"
              data-aos="fade-up"         
              data-aos-duration="600"    
              data-aos-delay="240"
          >
            Our servers handle massive computational power to process AI wallet mining seamlessly, while you enjoy a smooth, lightweight experience on your phone. 
            We carefully selected seven of the most efficient blockchains, combining strong hashing power with optimal server performance, so you get secure and reliable results with minimal effort.
          </p>
        </div>


          <div className="image-container"
           data-aos="fade-left"         
           data-aos-duration="600"    
           data-aos-delay="250">
            <img className="image-tilt" src={devImage} alt="Visual" />
          </div>

        </div>
      </div>
  );
};

export default DevSection;
